import {Dispatchable} from "../../../stem-core/base/Dispatcher";
import {IS_PRODUCTION, TEST_MODE} from "../../Constants";
import {delayThrottled} from "../../utils/Utils";


export type StyleObject = Record<string, string | number>;

export interface NodeElementOptions {
    nodeType?: string;
    style?: StyleObject;
    testId?: string;
    [key: string]: any;
}

// TODO @cleanup This Stem-like garbage is garbage
export class NodeElement extends Dispatchable {
    options: NodeElementOptions;
    node: HTMLElement;

    constructor(options: NodeElementOptions = {}, node: HTMLElement | null = null) {
        super();

        this.options = {...this.getDefaultOptions(), ...options};
        this.node = node || document.createElement(this.options.nodeType || "div");
        if (!IS_PRODUCTION || TEST_MODE) {
            if (this.options.testId) {
                this.node.setAttribute("test-id", this.options.testId);
            }
        }
        // TODO: Enable something similar to this at some point. This protects us from merchants' global styles
        //  affecting our components.
        // this.node.style.all = "unset";
    }

    getDefaultOptions(): NodeElementOptions {
        return {
            nodeType: "div",
            style: {},
        };
    }

    updateOptions(options: Partial<NodeElementOptions>) {
        Object.assign(this.options, options);
        this.refreshStyle();
        if (!IS_PRODUCTION || TEST_MODE) {
            if (this.node && options.testId) {
                this.node.setAttribute("test-id", options.testId);
            }
        }
    }

    refreshStyle() {
        this.setStyle(this.options.style);
    }

    mount(parentNode: HTMLElement, index: number | null = null) {
        if (index == null) {
            parentNode.appendChild(this.node);
        } else {
            parentNode.insertBefore(this.node, parentNode.children?.[index]);
        }
        this.refreshStyle();
        this.onMount();
    }

    setStyle(key: string | StyleObject, value?: string | number) {
        if (!this.node) {
            return;
        }
        if (typeof key === "object") {
            Object.assign(this.node.style, key);
        } else {
            this.node.style[key] = value;
        }
    }

    // TODO: Rename this method
    destroyNode() {
        this.cleanup();
        this.node?.remove();
        delete this.node;
    }

    onMount() {
        this.attachEventListener(window, "resize", delayThrottled(() => this.refreshStyle(), 100));
    }
}
